<template>
  <div id="menu" :class="{ 'loaded': menuLoaded }">
    <div class="adaptive-column-content">
      <content-loader title="Пожалуйста, подождите, мы загружаем меню" v-if="!menuLoaded" />
      <template v-else-if="currentCategory">
        <category-dishes-list
          :currentCategory="currentCategory"
          :title="currentCategory.title.rendered"
          :key="currentFirstLevelCategory.title.rendered"
          :dishes="currentCategory.acf.dishes" />
        <category-dishes-list
          v-if="specialCategories.length > 0"
          :isSpecialList="true"
          :title="specialCategories[1].title"
          :key="specialCategories[1].title"
          :dishes="specialCategories[1].method()" />
      </template>
      <template v-else>
        <menu-banners-slider />
        <smartphone-categories v-if="isSmartphone" />
        <div class="special-categories-content">
          <component
            v-for="(category, index) in specialCategories"
            :is="isSmartphone ? 'CategoryDishesSwiper' : 'CategoryDishesList'"
            :isSpecialList="true"
            :key="index"
            :title="category.title"
            :dishes="category.method()" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ContentLoader from '/src/components/ContentLoader'
  import CategoryDishesList from '/src/components/CategoryDishesList'
  import CategoryDishesSwiper from '/src/components/CategoryDishesSwiper'
  import SmartphoneCategories from '/src/blocks/SmartphoneCategories'
  import MenuBannersSlider from '/src/blocks/MenuBannersSlider'
  import { take, shuffle, filter } from 'lodash'

  export default {
    name: 'MenuPage',
    components: {
      ContentLoader,
      CategoryDishesList,
      SmartphoneCategories,
      CategoryDishesSwiper,
      MenuBannersSlider
    },
    data () {
      return {
        specialCategories: []
      }
    },
    methods: {
      getRandomDishes (n) {
        return take(shuffle(this.dishes), n)
      },
      getPopularDishes () {
        return filter(this.dishes, (dish) => {
          return dish.is_popular && !dish.season_offer
        })
      },
      getSeasonOffers () {
        return filter(this.dishes, (dish) => {
          return dish.season_offer
        })
      }
    },
    mounted () {
      this.specialCategories = [
        {
          title: 'Популярные блюда',
          dishesCount: this.isSmartphone ? 5 : 12,
          method: this.getPopularDishes
        },
        {
          title: 'Сезонные предложения',
          dishesCount: this.isSmartphone ? 5 : 12,
          method: this.getSeasonOffers
        }
        // {
        //   title: 'Случайные блюда (пример 2)',
        //   dishesCount: this.isSmartphone ? 7 : 8
        // }
      ]
    },
    computed: {
      ...mapGetters({
        currentCategory: 'menu/currentCategory',
        categories: 'menu/categories',
        dishes: 'menu/dishes',
        menuLoaded: 'menu/menuLoaded',
        currentFirstLevelCategory: 'menu/currentFirstLevelCategory'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/index/Menu.vue